//@ts-nocheck
import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import "@banno/jha-wc/src/icons/jha-icon-delete";
import "@banno/jha-wc/src/tables/jha-table/jha-table";
import "@banno/jha-wc/src/tables/jha-table-cell/jha-table-cell";
import "@banno/jha-wc/src/tables/jha-table-header/jha-table-header";
import "@banno/jha-wc/src/tables/jha-table-row/jha-table-row";
import "@banno/jha-wc/src/forms/jha-form-checkbox/jha-form-checkbox";
import "@banno/jha-wc/src/icons/jha-icon-information";
import "@banno/jha-wc/src/icons/jha-icon-edit";
import "@banno/jha-wc/src/icons/jha-icon-show";
import "@banno/jha-wc/src/buttons/jha-button/jha-button";
import { AddWorkflowStepPopup } from "./AddWorkflowStepPopup";
import DialogUtil from "@banno/jha-wc/src/js/utils/dialog-util";
import { openJhftDialog } from "../../Components/JhftJhaDialog";
import { EditWorkflowStepPopup } from "./EditWorkflowStepPopup";
import Cookies from "js-cookie";
import { decryptValue, stringComparison, getEnvApiUrl } from "../../utils/app-utils";
import { getRequest } from "../../utils/jha-fetch";
import { Apis } from "../../utils/api-constants";
import { showToast } from "@banno/jha-wc/src/js/utils/toast-util.js";
import { GlobalVariables } from "../../utils/constants";
import { getStepFunctionDisplayLabel } from "../../utils/step-function-display";

@customElement("workflow-steps-view")
export class WorkflowStepsView extends LitElement {
  static readonly styles = css`
    #workflowDiv {
      display: flex;
      flex-direction: column;
    }
    jha-table {
      flex: 1;
    }
    jha-table-header {
      width: 20vw;
    }
    #btnDiv {
      display: flex;
      margin-top: 20px;
      justify-content: end;
      padding-right: 15px;
      padding-left: 15px;      
    }
    jha-icon-warning-filled{
      fill: var(--jha-color-warning);      
     padding-left: 5px;
    }
    .aling-span-text{
     display: flex;
     align-items: center;
    }
       #filePattern {
    position: absolute;
    border-radius:4px;
    padding:8px;
    width: 500px;
    height: 50px;
    background:black;
    color:white;
    box-sizing:border-box;
    z-index:1061;
    display: none; 
  }
  
  .iconInfo:hover + #filePattern {
    display: block;
  }
  `;
  @property()
  toUpdate: "update";
  @property()
  stepIndex = 0;
  @property({ type: Array })
  workflowStepsData = [];
  @property()
  formData = {
    workflowName: "",
    WorkflowId: "",
    TransferType: "",
    BusinessUnitParticipant: stringComparison(decryptValue(Cookies.get("userType")), "BusinessAdmin") ? this.loggedUserBu?.toLowerCase() : "",
    sourceLocationPath: "",
    TriggerFilePattern: [] = [],
    DataFilePattern: [] = [],
    valid: false,
    isEdit: false,
    DeleteFiles: true
  };
  @property({ type: Object })
  workflowStepItem = {};
  @property({ type: Boolean })
  isReadOnlyUser = /readonly/i.test(decryptValue(Cookies.get("userRole")))

  /**
   * [ACME-1422] Cached Business Unit catalog used to resolve a friendly display
   * name from `formData.BusinessUnitParticipant` (the selected BU value/id) when
   * launching `AddWorkflowStepPopup`. The popup uses this to render the SMB
   * bucket preview as `{env}-smb-{slug}` matching what the API persists.
   */
  @property({ type: Array })
  businessUnits: Array<{ value: string; name: string }> = [];

  async connectedCallback() {
    super.connectedCallback();
    try {
      const response = await getRequest(getEnvApiUrl(Apis.GET_ALL_BUSINESSUNITVALUES));
      this.businessUnits = (response?.businessUnitValues ?? []).map((bu) => ({ value: bu.value, name: bu.name }));
    } catch (e) {
      // Non-fatal: popup falls back to buName when display name is unavailable.
      this.businessUnits = [];
    }
  }

  private resolveBuDisplayName(): string {
    const selected = this.formData?.BusinessUnitParticipant;
    if (!selected) return "";
    const match = this.businessUnits.find((bu) => bu.value?.toLowerCase() === selected.toLowerCase());
    return match ? match.name : "";
  }

  firstUpdated() {
    this.dispatch();
  }

  refreshTable(data) {
    this.workflowStepsData.push(data);
  }
  async onAddWorkflowStepsClick() {
    try {
      let lastDelete = false;
      if (this.workflowStepsData.length > 0) {
        this.workflowStepsData.forEach((element) => {
          if (
            ((stringComparison(element.deleteSourceFile, "true") ||
              element.deleteSourceFile == true)) && (!stringComparison(element.functionName, "UnprocessedFileArchive")) && (!stringComparison(element.functionName, "FileDelete"))
          ) {
            lastDelete = true;
          }
        });
      }
      const dlg = new AddWorkflowStepPopup(
        this.formData.TransferType,
        false,
        lastDelete,
        this.formData.TransferType,
        this.formData.isClone,
        this.formData.WorkflowName,
        this.formData.BusinessUnitParticipant,
        false
      );
      dlg.workflowSourceLocationPath = this.formData.sourceLocationPath ?? '';
      dlg.workflowId = this.formData.WorkflowId ?? '';
      // [ACME-1422] Bind friendly BU display name for the S3 SMB bucket preview.
      dlg.buDisplayName = this.resolveBuDisplayName();
      const data = await DialogUtil.awaitDialog({
        dialog: dlg,
      });
      if (!data) return;
      const snapshot = JSON.parse(JSON.stringify(data));
      this.stepIndex = this.workflowStepsData.length + 1;
      snapshot.stepIndex = this.stepIndex;
      this.workflowStepsData = [...this.workflowStepsData, snapshot];
      this.dispatch();
    } catch (e) { }
  }

  checkDeleteFlag(e: Event) {
    this.formData.DeleteFiles = e.detail.checked;
    this.dispatch();
  }
  async onEditWorkflowStepsClick(item, isViewOnly = false) {
    let saveStepIndex;
    saveStepIndex = item.stepIndex;
    try {
      this.workflowStepItem = item;
      let lastDelete = false;
      let stepIndex;
      if (this.workflowStepsData.length > 0) {
        this.workflowStepsData.forEach((element) => {
          if ((stringComparison(element.deleteSourceFile, "true") ||
            element.deleteSourceFile == true) && (!stringComparison(element.functionName, "UnprocessedFileArchive")) && (!stringComparison(element.functionName, "FileDelete"))) {
            stepIndex = element.stepIndex;
          }
        });
        if ((stringComparison(this.workflowStepItem.functionName, "UnprocessedFileArchive")) || (stringComparison(this.workflowStepItem.functionName, "FileDelete"))) {
          lastDelete = false;
        }
        else {
          if (this.workflowStepItem.stepIndex != stepIndex && stepIndex != undefined) {
            lastDelete = true;
          }
        }
      }
      const dlgEdit = new AddWorkflowStepPopup(item, true, lastDelete, this.formData.TransferType, this.formData.isClone, this.formData.WorkflowName, this.formData.BusinessUnitParticipant, isViewOnly);
      dlgEdit.workflowSourceLocationPath = this.formData.sourceLocationPath ?? '';
      dlgEdit.workflowId = this.formData.WorkflowId ?? '';
      // [ACME-1422] Bind friendly BU display name for the S3 SMB bucket preview.
      dlgEdit.buDisplayName = this.resolveBuDisplayName();
      const data = await DialogUtil.awaitDialog({
        dialog: dlgEdit,
      });
      if (!data) return;
      if (isViewOnly) return;
      let deleteIndex = this.workflowStepsData.indexOf(item);
      if (deleteIndex < 0) {
        deleteIndex = this.workflowStepsData.findIndex((s) => s.stepIndex === saveStepIndex);
      }
      if (deleteIndex < 0) {
        showToast({
          message: "Unable to update the workflow step. Please try again.",
          role: "danger",
          duration: GlobalVariables.TOAST_TIMEOUT,
        });
        return;
      }
      const snapshot = JSON.parse(JSON.stringify(data));
      snapshot.stepIndex = saveStepIndex;
      const updatedSteps = [...this.workflowStepsData];
      updatedSteps.splice(deleteIndex, 1, snapshot);
      this.workflowStepsData = updatedSteps;
      this.dispatch();
    } catch (e) { }
  }
  async onDeleteStepClick(item) {
    const result = await openJhftDialog({
      variant: "danger",
      title: "Delete Workflow Step",
      message: "Are you sure you want to delete this workflow step?",
      cancelLabel: "Cancel",
      confirmLabel: "Delete",
    });
    if (result !== "confirm") return;
    if (!this.onDeleteWorkflowStepsClick(item)) {
      showToast({
        message: "Unable to delete the workflow step. Please try again.",
        role: "danger",
        duration: GlobalVariables.TOAST_TIMEOUT,
      });
      return;
    }
    showToast({
      message: "Workflow Step is deleted.",
      role: "success",
      duration: GlobalVariables.TOAST_TIMEOUT,
    });
  }
  onDeleteWorkflowStepsClick(item): boolean {
    let deleteIndex = this.workflowStepsData.indexOf(item);
    if (deleteIndex < 0) {
      deleteIndex = this.workflowStepsData.findIndex((s) => s.stepIndex === item?.stepIndex);
    }
    if (deleteIndex < 0) return false;
    const updatedSteps = [...this.workflowStepsData];
    updatedSteps.splice(deleteIndex, 1);
    updatedSteps.forEach((element: any, index: number) => {
      element.stepIndex = index + 1;
    });
    this.workflowStepsData = updatedSteps;
    this.dispatch();
    return true;
  }
  dispatch() {
    this.dispatchEvent(
      new CustomEvent("onStepsChange", {
        detail: {
          workflowStepsData: [...this.workflowStepsData],
          deleteFiles: this.formData.DeleteFiles ?? true
        },
        bubbles: true,
        composed: true
      })
    );
  }
  render() {
    return this.formData.TransferType == "push" ?
      html`           
      <div id="workflowDiv">
       <div>
        <jha-form-checkbox
          data-id="deleteSourceFile"
          data-auto-id="deleteSourceFileCheckbox"
          .checked=${this.formData.DeleteFiles ?? true}
          ?disabled=${this.isReadOnlyUser}
          @change=${this.checkDeleteFlag}
        >
          <p style="font-size:large;">
            Delete files from Source Location Path after workflow execution?
          </p>
        </jha-form-checkbox>
        <jha-icon-information class="iconInfo"></jha-icon-information>
        <span id="filePattern">
          Files in the Source Location Path are deleted after workflow execution only if the workflow contains at least one step
        </span>         
        </div>
        <jha-table>
          <jha-table-row>
            <jha-table-header>NO.</jha-table-header>
            <jha-table-header>STEP NAME</jha-table-header>
            <jha-table-header>STEP FUNCTION</jha-table-header>
    ${this.isReadOnlyUser ? html`<jha-table-header></jha-table-header>` : html`
            <jha-table-header></jha-table-header>
             <jha-table-header></jha-table-header>`}
          </jha-table-row>
          ${this.workflowStepsData?.map(
        (item) => html`
              <jha-table-row>
                <jha-table-cell> <span class="aling-span-text">${item.stepIndex} ${item.isValidStep == false ? html`<jha-icon-warning-filled icon ></jha-icon-warning-filled>` : ''}</span></jha-table-cell>
                <jha-table-cell>${item.stepName}</jha-table-cell>
                <jha-table-cell>${getStepFunctionDisplayLabel(item.functionName)}</jha-table-cell>
                ${this.isReadOnlyUser ? html`
                <jha-table-cell>
                <jha-tooltip bottom text="View Workflow Step">
                  <jha-button
                    data-auto-id="viewWorkflowStepBtn"
                    sync
                    type="button"
                    icon
                    @click=${() => this.onEditWorkflowStepsClick(item, true)}
                  >
                    <jha-icon-show></jha-icon-show>
                  </jha-button>
                </jha-tooltip>
                </jha-table-cell>` : html`
                <jha-table-cell>
                <jha-tooltip bottom text="Edit Workflow Step">
                  <jha-button
                    data-auto-id="editWorkflowStepBtn"
                    sync
                    type="button"
                    icon
                    ?disabled=${this.isReadOnlyUser}
                    @click=${() => this.onEditWorkflowStepsClick(item)}
                  >
                    <jha-icon-edit></jha-icon-edit>
                  </jha-button>
                </jha-tooltip>
                </jha-table-cell>
                <jha-table-cell>
                <jha-tooltip bottom text="Delete Workflow Step">
                  <jha-button
                    data-auto-id="deleteWorkflowStepBtn"
                    sync
                    type="button"
                    icon
                    ?disabled=${this.isReadOnlyUser}
                    @click=${() => this.onDeleteStepClick(item)}
                  >
                    <jha-icon-delete></jha-icon-delete>
                  </jha-button>
                </jha-tooltip>
                </jha-table-cell>`}
              </jha-table-row>
            `
      )}
        </jha-table>
        <div id="btnDiv">
        <jha-tooltip bottom text="Click to Add Workflow Steps">
          <jha-button data-auto-id="addWorkflowStepBtn" sync outline large @click=${this.onAddWorkflowStepsClick} ?disabled=${this.isReadOnlyUser}
            ><jha-icon-plus slot="icon-left"></jha-icon-plus>Add Workflow
            Steps
            </jha-button
          >
        </jha-tooltip>
        </div>
      </div>
    ` :
      html`
      <div id="workflowDiv">
        <jha-table>
          <jha-table-row>
            <jha-table-header>NO.</jha-table-header>
            <jha-table-header>STEP NAME</jha-table-header>
            <jha-table-header>STEP FUNCTION</jha-table-header>
            ${this.isReadOnlyUser ? html`
            <jha-table-header></jha-table-header>
            ` : html`
             <jha-table-header></jha-table-header>
            <jha-table-header></jha-table-header>`}
          </jha-table-row>
          ${this.workflowStepsData?.map(
        (item) => html`
              <jha-table-row>
                <jha-table-cell> <span class="aling-span-text">${item.stepIndex} ${item.isValidStep == false ? html`<jha-icon-warning-filled icon ></jha-icon-warning-filled>` : ''}</span></jha-table-cell>
                <jha-table-cell>${item.stepName}</jha-table-cell>
                <jha-table-cell>${getStepFunctionDisplayLabel(item.functionName)}</jha-table-cell>
                 ${this.isReadOnlyUser ? html`<jha-table-cell>
                <jha-tooltip bottom text="View Workflow Step">
                  <jha-button
                    data-auto-id="viewWorkflowStepBtn"
                    sync
                    type="button"
                    icon
                    @click=${() => this.onEditWorkflowStepsClick(item, true)}
                  >
                    <jha-icon-show></jha-icon-show>
                  </jha-button>
                </jha-tooltip>
                </jha-table-cell>` : html`
                <jha-table-cell>
                <jha-tooltip bottom text="Edit Workflow Step">
                  <jha-button
                    data-auto-id="editWorkflowStepBtn"
                    sync
                    type="button"
                    icon
                    ?disabled=${this.isReadOnlyUser}
                    @click=${() => this.onEditWorkflowStepsClick(item)}
                  >
                    <jha-icon-edit></jha-icon-edit>
                  </jha-button>
                </jha-tooltip>
                </jha-table-cell>
                <jha-table-cell>
                <jha-tooltip bottom text="Delete Workflow Step">
                  <jha-button
                    data-auto-id="deleteWorkflowStepBtn"
                    sync
                    type="button"
                    icon
                    ?disabled=${this.isReadOnlyUser}
                    @click=${() => this.onDeleteStepClick(item)}
                  >
                    <jha-icon-delete></jha-icon-delete>
                  </jha-button>
                </jha-tooltip>
                </jha-table-cell>`}
              </jha-table-row>
            `
      )}
        </jha-table>
        <div id="btnDiv">
        <jha-tooltip bottom text="Click to Add Workflow Steps">
          <jha-button data-auto-id="addWorkflowStepBtn" sync outline large @click=${this.onAddWorkflowStepsClick} ?disabled=${this.isReadOnlyUser}
            ><jha-icon-plus slot="icon-left"></jha-icon-plus>Add Workflow
            Steps
            </jha-button
          >
        </jha-tooltip>
        </div>
      </div>
    ` ;
  }
}
declare global {
  interface HTMLElementTagNameMap {
    "workflow-steps-view": WorkflowStepsView;
  }
}

